import { render } from "./Journals.vue?vue&type=template&id=1b8f4941&scoped=true"
import script from "./Journals.vue?vue&type=script&lang=js"
export * from "./Journals.vue?vue&type=script&lang=js"

import "./Journals.vue?vue&type=style&index=0&id=1b8f4941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8f4941"]])

export default __exports__